var map = {
	"./Cardeck-is-full.svg": 194,
	"./carbon/add.svg": 8849,
	"./carbon/apps.svg": 7048,
	"./carbon/calendar.svg": 1090,
	"./carbon/checkbox-checked.svg": 5335,
	"./carbon/checkbox.svg": 6763,
	"./carbon/checkmark-outline.svg": 9638,
	"./carbon/chevron-down.svg": 8734,
	"./carbon/chevron-left.svg": 5253,
	"./carbon/chevron-right.svg": 2632,
	"./carbon/close.svg": 2836,
	"./carbon/delivery-parcel.svg": 9206,
	"./carbon/edit.svg": 9860,
	"./carbon/empty.svg": 4347,
	"./carbon/events.svg": 1211,
	"./carbon/info.svg": 7004,
	"./carbon/information.svg": 7594,
	"./carbon/launch.svg": 8769,
	"./carbon/locked.svg": 8853,
	"./carbon/logout.svg": 8386,
	"./carbon/misuse-outline.svg": 1847,
	"./carbon/notification.svg": 7453,
	"./carbon/overflow-menu-vertical.svg": 2197,
	"./carbon/plug.svg": 2268,
	"./carbon/portfolio.svg": 8016,
	"./carbon/printer.svg": 236,
	"./carbon/purchase.svg": 7193,
	"./carbon/renew.svg": 3071,
	"./carbon/search.svg": 6396,
	"./carbon/send.svg": 7930,
	"./carbon/temperature-celsius.svg": 9601,
	"./carbon/traffic-event.svg": 5556,
	"./carbon/trash-can.svg": 2415,
	"./carbon/user-settings.svg": 3869,
	"./carbon/user.svg": 8225,
	"./carbon/van.svg": 1423,
	"./carbon/view.svg": 4523,
	"./carbon/warning-alt.svg": 6794,
	"./carbon/warning.svg": 732,
	"./check-pink.svg": 3107,
	"./check-white.svg": 3014,
	"./checkmark.svg": 3181,
	"./close.svg": 3222,
	"./date.svg": 8406,
	"./dropdown-arrows.svg": 3624,
	"./error.svg": 4312,
	"./plus.svg": 4241,
	"./spinner.svg": 3317,
	"./switch.svg": 2498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8893;